// extracted by mini-css-extract-plugin
module.exports = {"AccordionFaq_container":"AccordionFaq_AccordionFaq_container__2Lo5d","Accordion":"AccordionFaq_Accordion__1by65","AccordionFaq_header":"AccordionFaq_AccordionFaq_header__3tL9O"};